// extracted by mini-css-extract-plugin
export default {"SuggestedColors":"styles_SuggestedColors__6a6Ng"};